
















import { Component, Vue, Emit } from 'vue-property-decorator'

@Component({
    components: {
    },
})
export default class ChoiceGhost extends Vue {
  private page: number = 0 // 当前换页index
  private count: number = 18 // 当前小鬼的数量
  private changeBG: boolean = false // 是否为长屏幕

  private ghostsDetail: any = [
      {
          randomName: ['一个字饿', '满脑子都是你', '甲方爸爸不让睡', '满脑是李现', '碌碌无为焦虑爆发鬼', '入睡焦虑发作', '沉迷工作与学习', '我真没用丧+1', '缺一句晚安', '私生活不如意']
      },
      {
          randomName: ['吃撑了', '缺一句晚安', '追剧上头', '满脑是坤坤', '看完这集还不睡煲剧鬼', '一直煲剧一直爽', '沉沦追剧难自拔', '等一句表白', '手机真是偷睡眠的小妖精']
      },
      {
          randomName: ['喝了超大杯奶茶', '心里有事', '沉迷游戏', '王者农药N连跪', '嫌弃平庸野心浮躁鬼', '浮躁的内心', '沙雕网友哈哈哈哈哈哈哈', '4小时怎么样睡有8小时的质量', '是我忧国忧民的心情', '想太多']
      },
      {
          randomName: ['咖啡喝多', '生活有点迷茫', '手机太好玩', '为驾照发愁', '贫穷不睡更贫穷鬼', '贫穷', '穷困眼不困', '迎接贫穷的明天', '心里有事', '自己没用']
      },
      {
          randomName: ['蚊子咬我', '私生活不如意', '中了抖音的毒', '倒时差', '入夜必定烦躁鬼', '入夜烦躁', '等一句表白', '深夜研究垃圾分类', '还有4小时18分钟睡眠时间', '心情不漂亮']
      },
      {
          randomName: ['身体抱恙', '心情不漂亮', '想朱一龙', '来到新环境', '今天又让自己尴尬鬼', '室友不睡我甭想睡', '今天出门遇见EX', '感觉房间里有另一个朋友', '生活有点迷茫', '灵魂在蹦迪']
      },
      {
          randomName: ['有人呼噜声太响', '担忧未来 ', '想易烊千玺', '手机太好玩', '等着世界再说一句话的孤独鬼', '害怕孤独', '单身无药可救', '舌头到底该怎么放', '胳膊到底该怎么放', '家庭琐事']
      },
      {
          randomName: ['收入太低', '想太多  ', '想王嘉尔', '主动熬夜', '脑壳加速运行不安分鬼', '报复性熬夜', '甲方爸爸又发威', '今天吵架怎么又输了', '身体抱恙', '担忧未来']
      },
      {
          randomName: ['开支太大', '自己没用', '想朱亚文', '遗传治不好', '喝点一定能睡嗜酒鬼', '酒精是我的入睡剂', '以酒渡夜', '月色太美']
      },
      {
          randomName: ['房贷车贷', '灵魂在蹦迪', '修仙', '购物逛High了', '入夜戏最多幻想鬼', '舔屏男神', '暗恋的人还没睡', '日常撩妹不睡', '日常撩汉不睡', '相思上瘾']
      },
      {
          randomName: ['信用卡未还', '家庭琐事', '室友好吵', '纯粹想多玩一会', '睡前规律性抑郁鬼', '规律性抑郁', '床太大睡得慌', '过去回忆循环播放', '逃避明天', '精力太旺盛']
      },
      {
          randomName: ['白条未还', '精力太旺盛', '研究垃圾分类', '晚上做真实自己', '真香警告奶茶鬼', '奶茶精附身', '奶茶过量', '奶茶喝嗨了', '红茶绿茶柠檬茶茶茶精本精']
      },
      {
          randomName: ['花呗未还', '缺少sex生活', '白天睡太多', '听到关于Ta的事', '消息不回会想你鬼', '消息不回在想念', '思念一个人', '社交不能停', '被自己美醒了', '被自己帅醒了']
      },
      {
          randomName: ['失恋', '孩子操碎心', '祖国未统一', '思考人生', '赢了这把我就睡鬼', '不赢这局我不睡', '手机提醒不让我睡', '抓紧时间玩一下手机', '手拿手机心装剧场']
      },
      {
          randomName: ['没有女盆友', '沉迷学习', '月色太美', '证明自己还年轻', '明天一定做好Deadline鬼', '明天就是Deadline了', '催稿消息响不停', '拖延症的制裁', '修仙']
      },
      {
          randomName: ['缺个男盆友', '沉迷工作', '枕头不舒服', '肝论文', '回到过去悔恨鬼', '报复性熬夜修仙', '夜深犯饿吃点啥', '明天要早起不要睡过头', '有人呼噜声太响', '孩子操碎心']
      },
      {
          randomName: ['一个字穷', '压力大', '挑床', '补作业', '百万负翁鬼', '花呗/白条/信用卡未还', '又到还款日', '贫穷令人为难', '房贷还不清', '缺钱']
      },
      {
          randomName: ['缺钱', '工作堆成山', '体验熬夜快感', '不开心', '幻想自己能暴富鬼', '暴富是唯一催眠剂', '钱多花不完', '研究致富', '收入太低', '开支太大']
      },
  ]

  private ghosts: ghost[] = []
  private backGhosts: ghost[] = []
  private randomNameMode: boolean = false
  private selectGhosts: ghost[] = []

  private addBackGhosts (): void {
      for (let i = 1; i < this.count + 1; i++) {
          const iString = (i + '').padStart(2, '0')
          this.backGhosts.push({
              detail: {
                  randomName: []
              },
              name: '', // 当前名称
              index: i,
              select: false,
              img: require(`../assets/GHOSTS/img_ghost_${iString}@3x.png`),
              bg: require(`../assets/GHOSTS/bg_ghost_${iString}@3x.png`),
          } as ghost)
      }
  }

  // ghost 处理 的代码
  private ghostsDetailChange (i, randomMode = false) {
      const ghost = this.backGhosts[i]
      ghost.detail = this.ghostsDetail[i]
      const one = this.$root.configData.type === 'reason' ? 0 : 4
      const two = this.$root.configData.type === 'reason' ? 3 : ghost.detail.randomName.length - 1
      randomMode ? ghost.name = ghost.detail.randomName[this.$wjh.randomNum(one, two)] : ghost.name = ghost.detail.randomName[this.$root.configData.type === 'reason' ? 0 : 4] // 默认为第二个文案
      this.ghosts.push(this.backGhosts[i])
  }

  private change () {
      // @ts-ignore
      _hmt.push(['_trackEvent', 'nav', 'click', '换一批'])
      this.ghosts = []
      this.$nextTick(() => {
          this.page++
          const allPage: number = Math.floor(this.count / 6) // 全部页数
          const last = this.count % 6 // 剩下的单个个数
          if ((this.page === allPage + 1 && last === 0)) {
              this.page = 1
              this.randomNameMode = true
          }
          if (this.page <= allPage) {
              for (let i = (this.page - 1) * 6; i < (this.page * 6); i++) {
                  this.ghostsDetailChange(i, this.randomNameMode)
              }
              return
          }
          if (this.page === allPage + 1) {
              for (let i = (this.page - 1) * 6; i < ((this.page - 1) * 6) + last; i++) {
                  this.ghostsDetailChange(i, this.randomNameMode)
              }
              this.page = 0
          }
      })
  }

  @Emit('parentChange')
  private selectEvent (data: ghost, event: any) {
      // @ts-ignore
      _hmt.push(['_trackEvent', 'nav', 'click', `ghost=${data.index}`, data.index])
      event.preventDefault()
      if (this.selectGhosts.length >= 5) {
          this.$parent.$parent.showTips('最多只能选择5个哦')
          return
      }
      data.select = true
      setTimeout(() => {
          data.select = false
      }, 1000)
      this.selectGhosts.push(JSON.parse(JSON.stringify(data)))
  }

  private mounted () {
      setTimeout(() => {
          if ((window.innerHeight / window.innerWidth) > 1.8) {
              this.changeBG = true
          }
      }, 300)

      this.addBackGhosts()
      this.change()
  }
}
